








































































import Vue from "vue";
import Toolbar from "../components/toolbar/Toolbar.vue";
import storeHelper from "../store/store-helper";
import { Task } from "@/tasks";
import Utils from "@/utils";
import TasksTab from "../components/tasks/TasksTab.vue";
import NotificationsTab from "../components/tasks/NotificationsTab.vue";
import { Statistics } from "@infoland/iprova-api";
import { FeatureType, TaskFilterOption } from "../enums";
import { Constants } from "@/constants";
import { Controllers } from "@infoland/iprova-api";
import { utils } from "@amcharts/amcharts4/core";
import { cookies } from "@/enums";
import moment from "moment";
import Shared from "@/shared";
import { TranslateResult } from "vue-i18n";
import { UserStatisticsDto } from "@/api/UserStatisticsDto";

export default Vue.extend({
    name: "Tasks",
    components: { Toolbar, TasksTab, NotificationsTab },
    props: {
        tab: { default: "tasks" },
        filter: String as () => TaskFilterOption,
        portalId: Number
    },
    data: () => {
        return {
            tasksLoaded: false,
            notificationsLoaded: false,
            refreshTimer: null,
            tasks: [] as Task[],
            notifications: [] as Task[],
            constants: { ...Constants },
            numberOfSelectedTasks: 0 as number,
            iQualifySynced: false as boolean
        };
    },
    async created() {
        if (this.$readOnlyMode) {
            let path = `${Shared.iProvaUrl}/management/general/readonlyerror.aspx`;
            window.open(path, "_self");
        }

        this.setRefreshTimer();
        window.addEventListener("focus", () => this.loadTasksOrNotificationsAsync(this.tab, true));
    },
    destroyed() {
        this.clearRefreshTimer();
        window.removeEventListener("focus", () => this.loadTasksOrNotificationsAsync(this.tab, true));
    },
    mounted() {},
    watch: {
        tab: {
            immediate: true,
            handler: function (newTab: string) {
                this.loadTasksOrNotificationsAsync(newTab);
            }
        },
        storeTasks: {
            immediate: true,
            handler: function (updatedTasks: Task[]) {
                //check if any tasks were modified so we can update the view
                const cleanUpdatedTasks = updatedTasks.map(t => ({
                    id: t.id,
                    last_modified_date_time: t.last_modified_date_time,
                    read: t.read,
                    is_important: t.is_important,
                    postponed_until_date: t.postponed_until_date
                }));
                const cleanCurrentTasks = this.tasks.map(t => ({
                    id: t.id,
                    last_modified_date_time: t.last_modified_date_time,
                    read: t.read,
                    is_important: t.is_important,
                    postponed_until_date: t.postponed_until_date
                }));

                if (JSON.stringify(cleanUpdatedTasks) !== JSON.stringify(cleanCurrentTasks)) {
                    this.tasks = updatedTasks;
                }
            }
        },
        storeNotifications: {
            immediate: true,
            handler: function (updatedNotifications: Task[]) {
                //check if any notifications were modified so we can update the view
                const cleanUpdatedNotifications = updatedNotifications
                    .filter(n => !n.finished)
                    .map(t => ({
                        id: t.id,
                        last_modified_date_time: t.last_modified_date_time,
                        read: t.read,
                        is_important: t.is_important
                    }));
                const cleanCurrentNotifications = this.notifications.map(t => ({
                    id: t.id,
                    last_modified_date_time: t.last_modified_date_time,
                    read: t.read,
                    is_important: t.is_important
                }));
                if (JSON.stringify(cleanCurrentNotifications) !== JSON.stringify(cleanUpdatedNotifications)) {
                    this.notifications = updatedNotifications;
                }
            }
        }
    },
    computed: {
        toolbarTitle(): string {
            if (this.tab == null) {
                return this.$t("general.toolbar.tasks").toString();
            } else {
                if (this.tab == "tasks") {
                    return this.$t("general.toolbar.tasks").toString();
                } else {
                    return this.$t("general.toolbar.notifications").toString();
                }
            }
        },
        storeTasks(): Task[] {
            return storeHelper.tasksStore.tasks;
        },
        storeNotifications(): Task[] {
            return storeHelper.notificationsStore.notifications;
        },
        isAnonymousUser(): Boolean {
            return Utils.isAnonymousUser(this.$user.user_id);
        },
        userStatistics(): UserStatisticsDto | null {
            if (this.isAnonymousUser || !this.$user) return null;
            return this.$user.statistics;
        },
        mdAndDown(): boolean {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        ZenyaRed(): string {
            return "#E41B51";
        }
    },
    methods: {
        setRefreshTimer() {
            //Refresh tasks or notifications every 30 seconds
            this.refreshTimer = setInterval(() => this.loadTasksOrNotificationsAsync(this.tab, true), 30 * 1000);
        },
        clearRefreshTimer() {
            clearInterval(this.refreshTimer);
        },
        async loadTasksAsync(loadInBackground: boolean = false): Promise<void> {
            this.tasksLoaded = loadInBackground;
            await storeHelper.tasksStore.loadTasksAsync();
            this.tasksLoaded = true;
        },
        async loadNotificationsAsync(loadInBackground: boolean = false): Promise<void> {
            this.notificationsLoaded = loadInBackground;
            await storeHelper.notificationsStore.loadNotificationsAsync();
            this.notificationsLoaded = true;
        },
        async loadTasksOrNotificationsAsync(tab: string, loadInBackground: boolean = false): Promise<void> {
            if (!this.iQualifySynced) await this.synciQualifyTasks();
            if (!loadInBackground || (loadInBackground && !document.hidden)) {
                if (tab === "tasks") await this.loadTasksAsync(loadInBackground);
                else if (tab === "notifications") await this.loadNotificationsAsync(loadInBackground);
            }
        },
        async synciQualifyTasks(): Promise<void> {
            this.iQualifySynced = true;
            if (await this.checkIfiQualifyConnectorEnabled()) {
                const cookie = Utils.getCookie(cookies.iQualifyTaskNoRefreshTill);
                if (cookie && cookie.length && moment() < moment(cookie)) return;

                try {
                    await Promise.race([
                        Controllers.GenericController.getAsync<string>(Shared.iProvaUrl + "/iqualifyconnector/iqualifytasksync.ashx", false),
                        new Promise((resolve, reject) => {
                            setTimeout(() => {
                                reject("timeout");
                            }, 2500);
                        })
                    ]);
                } catch (error) {
                    if (error != "timeout") {
                        storeHelper.siteStore.setSnackBarMessage(this.$t("tasks.errorMessages.iqualify_task_sync_error"));
                        Utils.setCookie(cookies.iQualifyTaskNoRefreshTill, moment().add(1, "hour"));
                    }
                }
            }
        },
        async checkIfiQualifyConnectorEnabled(): Promise<boolean> {
            const iQualifyConnector = await storeHelper.FeaturesStore.featureByType(FeatureType.iqualify_connector);
            return !!iQualifyConnector?.enabled;
        }
    }
});
